import standardPageSizes from 'pdfmake/src/standardPageSizes'
import { find, propEq, reverse } from 'ramda'

export const paperSizes = [
  { name: 'Letter', pageSize: 'LETTER' },
  { name: 'Legal', pageSize: 'LEGAL' },
  { name: 'Tabloid', pageSize: 'TABLOID' },
  {
    name: '4x6',
    label: '4x6 in',
    pageSize: { width: 288, height: 432 },
    dailyEventOnly: true,
    compact: true,
    defaults: {
      hideEventDescription: true,
      hideEndTime: true,
    },
  },
]

export const getPaperSize = (name) => find(propEq(name, 'name'), paperSizes) || paperSizes[0]

export const pdfPageSize = (name) => getPaperSize(name).pageSize

const printPaperSizes = ({ pageSize = 'Letter', pageOrientation }) => {
  const paperPageSize = getPaperSize(pageSize).pageSize

  let size = typeof paperPageSize === 'string' ? standardPageSizes[paperPageSize] : [paperPageSize.width, paperPageSize.height]

  if (pageOrientation !== 'portrait') {
    size = reverse(size)
  }

  const [width, height] = size
  const ratio = height / width
  return [width, height, ratio]
}

export default printPaperSizes
